import { render, staticRenderFns } from "./one2morechoice.vue?vue&type=template&id=3f8b23b6&scoped=true&"
import script from "./one2morechoice.vue?vue&type=script&lang=js&"
export * from "./one2morechoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8b23b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\english\\new-evaluation\\src\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f8b23b6')) {
      api.createRecord('3f8b23b6', component.options)
    } else {
      api.reload('3f8b23b6', component.options)
    }
    module.hot.accept("./one2morechoice.vue?vue&type=template&id=3f8b23b6&scoped=true&", function () {
      api.rerender('3f8b23b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/one2morechoice/one2morechoice.vue"
export default component.exports